;(() => {
  const productTabs = document.querySelector('.product-tabs')
  if (productTabs) {
    productTabs
      .querySelectorAll('button[data-tab-toggle]')
      .forEach((tab, index) => {
        if (index === 0) {
          tab.classList.add('active')
        }
        tab.addEventListener('click', (event) => {
          removeActiveClasses()
          event.target.classList.add('active')
          const clickedTab = event.target.getAttribute('data-tab-toggle')
          document
            .querySelectorAll(`.tabs div[data-tab]`)
            .forEach((element) => {
              element.style.display = 'none'
            })
          document.querySelector(
            `.tabs div[data-tab="${clickedTab}"]`
          ).style.display = 'block'
        })
      })

    function removeActiveClasses() {
      productTabs.querySelectorAll('button[data-tab-toggle]').forEach((tab) => {
        tab.classList.remove('active')
      })
    }
  }
})()
